export const FLAG_GETTING_VIEWS = 'FLAG_GETTING_VIEWS';
export const GET_VIEWS = 'GET_VIEWS';
export const CLEAR_VIEWS = 'CLEAR_VIEWS';
export const FLAG_VIEW_ACTIVITY = 'FLAG_VIEW_ACTIVITY';
export const GET_VIEW = 'GET_VIEW';
export const CLEAR_VIEW = 'CLEAR_VIEW';